const ActionTypes={
    GET_COLOD:"GET_COLOD",
    GET_COLOD_AGAIN:"GET_COLOD_AGAIN",
    GET_FIRST_USED_CARD:"GET_FIRST_USED_CARD",
    TAKE_CARD_COMPUTER:"TAKE_CARD_COMPUTER",
    THROW_CARD_COMPUTER:"THROW_CARD_COMPUTER",
    COMPUTER_CLEAR:"COMPUTER_CLEAR",
    TAKE_CARD_USER:"TAKE_CARD_USER",
    THROW_CARD_USER:"THROW_CARD_USER",
    USER_CLEAR:"USER_CLEAR",
    THROW_SEVEN:"THROW_SEVENS",
    CHANGE_MAST:"CHANGE_MAST",
    RESTART:"RESTART"
}
export default ActionTypes;
